import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, IconButton, Typography } from '@mui/material';
import {
  DescriptionOutlined,
  VisibilityOutlined,
  MoreHoriz as MoreIcon,
} from '@mui/icons-material';
import { Form } from '../../types';
import { EditIcon, GridDotsIcon } from '../shared/Icons';
import { formatDate, formTypeLabel, responseCountLabel } from './utils';

interface FormListRowProps {
  form: Form;
  editPath: string;
  responsesPath: string;
  onPreview: () => void;
  onOpenMenu: (anchor: HTMLElement) => void;
  onEdit: (editPath: string) => void;
}

export const FormListRow: React.FC<FormListRowProps> = ({
  form,
  editPath,
  responsesPath,
  onPreview,
  onOpenMenu,
  onEdit,
}) => (
  <Box className="form-list-row">
    <Box className="form-list-row-inner">
      <Box className="form-list-row-main">
        <Box
          className={`form-list-row-icon${
            form.formType === 'multistep' ? ' form-list-row-icon--multistep' : ''
          }`}
          aria-hidden
        >
          <DescriptionOutlined sx={{ fontSize: 20 }} />
        </Box>
        <Box className="form-list-row-text">
          <Typography
            component="button"
            type="button"
            onClick={() => onEdit(editPath)}
            className="form-list-title"
            title={form.name}
          >
            {form.name || 'Untitled form'}
          </Typography>
          <Box className="form-list-meta">
            <Typography className="form-list-meta-text form-list-meta-hide-mobile">
              Created on: {formatDate(form.createdAt)}
            </Typography>
            <Typography className="form-list-meta-text form-list-meta-hide-mobile">&bull;</Typography>
            <Typography
              className={`form-list-meta-text form-list-meta-hide-mobile${
                form.formType === 'single' ? '' : ' form-list-meta-text--accent'
              }`}
            >
              {formTypeLabel(form)}
            </Typography>
            <Typography className="form-list-meta-text form-list-meta-hide-mobile">&bull;</Typography>
            <Typography className="form-list-meta-text">
              {responseCountLabel(form)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="form-list-row-actions">
        <Button
          className="form-list-row-btn form-list-row-btn--edit"
          onClick={() => onEdit(editPath)}
          variant="outlined"
          startIcon={<EditIcon />}
        >
          Edit
        </Button>
        <Button
          className="form-list-row-btn form-list-row-btn--secondary form-list-row-btn--responses"
          component={RouterLink}
          to={responsesPath}
          variant="outlined"
          startIcon={<GridDotsIcon />}
          aria-label="All responses"
        >
          <span className="form-list-row-btn-label">All Responses</span>
        </Button>

        <Button
          className="form-list-row-btn form-list-row-btn--secondary"
          variant="outlined"
          startIcon={<VisibilityOutlined />}
          onClick={onPreview}
          aria-label="Preview"
        >
          <span className="form-list-row-btn-label">Preview</span>
        </Button>
        <IconButton
          className="form-list-round-btn"
          aria-label="More actions"
          onClick={(e) => onOpenMenu(e.currentTarget)}
        >
          <MoreIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Box>
  </Box>
);
